<div class="container welcome">
    <h2>Cadastro concluído com sucesso.<br/> Seja Bem-vindo a Colloca!</h2>

    <a [routerLink]="['/']" class="custom-primary" mat-raised-button color="primary">Continuar</a>
</div>